module.exports = __webpack_public_path__ + "img/porfolio-euro.8b74c8d4.png";